import React from 'react';
import './modalprogramas.css';

function ModalProgramas({
  isOpen,
  editingId,
  formData,
  inputValues,
  onInputChange,
  onArrayInputChange,
  onAddArrayItem,
  onRemoveArrayItem,
  onMoveArrayItem,
  onSubmit,
  onClose,
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{editingId ? 'Editar Programa' : 'Crear Nuevo Programa'}</h3>
          <button className="btn-close" onClick={onClose}>
            ×
          </button>
        </div>

        <form onSubmit={onSubmit} className="programa-form">
          {/* Campos básicos */}
          <div className="form-row">
            <div className="form-group">
              <label>Nombre *</label>
              <input
                type="text"
                name="nombre"
                value={formData.nombre}
                onChange={onInputChange}
                placeholder="Nombre del programa"
                required
              />
            </div>
            <div className="form-group">
              <label>Código *</label>
              <input
                type="text"
                name="codigo"
                value={formData.codigo}
                onChange={onInputChange}
                placeholder="Código único"
                required
                disabled={!!editingId}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Categoría</label>
              <input
                type="text"
                name="categoria"
                value={formData.categoria}
                onChange={onInputChange}
                placeholder="Ej: Programación, Diseño"
              />
            </div>
          </div>

          <div className="form-group full-width">
            <label>Descripción</label>
            <textarea
              name="descripcion"
              value={formData.descripcion}
              onChange={onInputChange}
              placeholder="Descripción del programa"
              rows="3"
            />
          </div>

          <div className="form-group full-width">
            <label>Descripción Corta (para cards)</label>
            <textarea
              name="descriptionp"
              value={formData.descriptionp}
              onChange={onInputChange}
              placeholder="Descripción corta que se mostrará en las tarjetas"
              rows="2"
            />
          </div>

          <div className="form-group full-width">
            <label>Pensum (Plan de Estudios)</label>
            <textarea
              name="pensum"
              value={formData.pensum}
              onChange={onInputChange}
              placeholder="Contenido del programa"
              rows="3"
            />
          </div>

          <div className="form-group full-width">
            <label>Perfil del Egresado</label>
            <textarea
              name="perfil_egresado"
              value={formData.perfil_egresado}
              onChange={onInputChange}
              placeholder="¿Qué podrá hacer el estudiante al finalizar?"
              rows="2"
            />
          </div>

          <div className="form-group full-width">
            <label>Campo Laboral</label>
            <textarea
              name="campo_laboral"
              value={formData.campo_laboral}
              onChange={onInputChange}
              placeholder="Oportunidades de empleo"
              rows="2"
            />
          </div>

          <div className="form-group full-width">
            <label>Requisitos</label>
            <div className="array-input">
              <input
                type="text"
                value={inputValues.requisitos}
                onChange={onArrayInputChange}
                name="requisitos"
                placeholder="Ej: Tener secundaria completa"
              />
              <button
                type="button"
                className="btn-add"
                onClick={() => onAddArrayItem('requisitos')}
              >
                +
              </button>
            </div>
            <div className="array-tags">
              {formData.requisitos.map((item, index) => (
                <div key={index} className="tag">
                  {item}
                  <button
                    type="button"
                    className="tag-remove"
                    onClick={() => onRemoveArrayItem('requisitos', index)}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="form-group full-width">
            <label>Modalidades</label>
            <div className="array-input">
              <input
                type="text"
                value={inputValues.modalidades}
                onChange={onArrayInputChange}
                name="modalidades"
                placeholder="Ej: Presencial, Virtual"
              />
              <button
                type="button"
                className="btn-add"
                onClick={() => onAddArrayItem('modalidades')}
              >
                +
              </button>
            </div>
            <div className="array-tags">
              {formData.modalidades.map((item, index) => (
                <div key={index} className="tag">
                  {item}
                  <button
                    type="button"
                    className="tag-remove"
                    onClick={() => onRemoveArrayItem('modalidades', index)}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Arrays dinámicos */}
          <div className="form-group full-width">
            <label>Materias Clave</label>
            <div className="array-input">
              <input
                type="text"
                value={inputValues.materias_claves}
                onChange={onArrayInputChange}
                name="materias_claves"
                placeholder="Ej: Matemáticas"
              />
              <button
                type="button"
                className="btn-add"
                onClick={() => onAddArrayItem('materias_claves')}
              >
                +
              </button>
            </div>
            <div className="array-tags">
              {formData.materias_claves.map((item, index) => (
                <div key={index} className="tag">
                  {item}
                  <button
                    type="button"
                    className="tag-remove"
                    onClick={() => onRemoveArrayItem('materias_claves', index)}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="form-group full-width">
            <label>Habilidades</label>
            <div className="array-input">
              <input
                type="text"
                value={inputValues.habilidades}
                onChange={onArrayInputChange}
                name="habilidades"
                placeholder="Ej: Programación"
              />
              <button
                type="button"
                className="btn-add"
                onClick={() => onAddArrayItem('habilidades')}
              >
                +
              </button>
            </div>
            <div className="array-tags">
              {formData.habilidades.map((item, index) => (
                <div key={index} className="tag">
                  {item}
                  <button
                    type="button"
                    className="tag-remove"
                    onClick={() => onRemoveArrayItem('habilidades', index)}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="form-group full-width">
            <label>URLs de Imágenes (Cards)</label>
            <div className="array-input">
              <input
                type="text"
                value={inputValues.cards}
                onChange={onArrayInputChange}
                name="cards"
                placeholder="Ej: https://ejemplo.com/imagen.jpg"
              />
              <button
                type="button"
                className="btn-add"
                onClick={() => onAddArrayItem('cards')}
              >
                +
              </button>
            </div>
            <div className="array-cards">
              {formData.cards.map((url, index) => (
                <div key={index} className="card-preview">
                  <img src={url} alt={`Card ${index + 1}`} />
                  <button
                    type="button"
                    className={`card-star ${formData.cardPrincipal === url ? 'active' : ''}`}
                    onClick={() => onInputChange({ target: { name: 'cardPrincipal', value: url } })}
                    title="Marcar como principal"
                  >
                    ★
                  </button>
                  <button
                    type="button"
                    className="card-remove"
                    onClick={() => onRemoveArrayItem('cards', index)}
                  >
                    ×
                  </button>
                  <div className="card-action-buttons">
                    <button
                      type="button"
                      className="card-move card-move-left"
                      onClick={() => onMoveArrayItem('cards', index, index - 1)}
                      title="Mover a la izquierda"
                      disabled={index === 0}
                    >
                      ‹
                    </button>
                    <button
                      type="button"
                      className="card-move card-move-right"
                      onClick={() => onMoveArrayItem('cards', index, index + 1)}
                      title="Mover a la derecha"
                      disabled={index === formData.cards.length - 1}
                    >
                      ›
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="form-group full-width">
            <label>Costes (MAOP)</label>
            <div className="array-input doble-input">
              <input
                type="text"
                value={inputValues.coste_definicion || ''}
                onChange={onArrayInputChange}
                name="coste_definicion"
                placeholder="Definición del coste"
              />
              <input
                type="number"
                value={inputValues.coste_valor || ''}
                onChange={onArrayInputChange}
                name="coste_valor"
                placeholder="Valor"
              />
              <button
                type="button"
                className="btn-add"
                onClick={() => onAddArrayItem('costes', { definicion: inputValues.coste_definicion, valor: inputValues.coste_valor })}
              >
                +
              </button>
            </div>
            <div className="array-tags">
              {formData.costes && formData.costes.map((item, index) => {
                const definicion = typeof item === 'object' && item !== null ? item.definicion : item;
                const valor = typeof item === 'object' && item !== null ? item.valor : '';
                return (
                  <div key={index} className="tag coste-tag">
                    <span className="coste-text">{definicion} — {valor}</span>
                    <button
                      type="button"
                      className="tag-remove"
                      onClick={() => onRemoveArrayItem('costes', index)}
                    >
                      ×
                    </button>
                    <div className="tag-move">
                      <button
                        type="button"
                        className="tag-move-left"
                        onClick={() => onMoveArrayItem('costes', index, index - 1)}
                        disabled={index === 0}
                      >
                        ‹
                      </button>
                      <button
                        type="button"
                        className="tag-move-right"
                        onClick={() => onMoveArrayItem('costes', index, index + 1)}
                        disabled={index === (formData.costes.length - 1)}
                      >
                        ›
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="programas-btn-cancel"
              onClick={onClose}
            >
              Cancelar
            </button>
            <button type="submit" className="btn-submit">
              {editingId ? 'Actualizar' : 'Crear'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModalProgramas;
